import { useQuery, useQueryClient } from '@tanstack/react-query';
import { QueryKeys } from 'utils/queryKeys';
import { ContentType } from 'utils/getContentType';
import { apiDocumentServiceRepository } from '../../services/repositories/implementations/ApiDocumentServiceRepository.ts';

type UseGetPreviewByDocumentIdOptions = {
  enabled?: boolean;
};

/**
 * @deprecated Use useContentMetadata instead.
 */
export const useGetPreviewByDocumentId = (documentId: string, options?: UseGetPreviewByDocumentIdOptions) => {
  const queryClient = useQueryClient();
  return useQuery({
    // Not using QueryKeys.getDocumentMetadataByContentId — we don't have the contentId yet.
    // This query resolves it via documentId, then seeds the canonical cache entry so consumers
    // of useContentMetadata get the data without a second fetch.
    queryKey: QueryKeys.getDocumentById(documentId),
    queryFn: async () => {
      const result = await apiDocumentServiceRepository.getDocumentMetadataByDocumentId({ documentId });

      if (result?.contentId) {
        queryClient.setQueryData(QueryKeys.getDocumentMetadataByContentId(ContentType.DOCUMENT, result.contentId), result);
      }

      return result;
    },
    enabled: !!documentId && (options?.enabled ?? true),
  });
};
